import { Avatar, Box, MenuItem, MenuList, Typography, TypographyProps } from '@mui/material';

import { stringToColor } from './utils';
import { FleetRef, FleetVerificationStatus } from '../../../../domain/fleet-verification';

type StatusDisplayInfo = { label: string; color: TypographyProps['color'] };

const statusToDisplayInfo: Record<FleetVerificationStatus, StatusDisplayInfo> = {
  not_started: { label: 'Not started', color: 'text.secondary' },
  in_progress: { label: 'Need more information', color: 'warning.dark' },
  submitted: { label: 'Submitted, awaiting verification', color: 'text.secondary' },
};

const statusPriority: Record<FleetVerificationStatus, number> = {
  in_progress: 0,
  not_started: 1,
  submitted: 2,
};

type FleetPickerProps = {
  onChange: (newId: string) => void;
  options: FleetRef[];
  value?: string;
};

function FleetPicker({ onChange, options, value }: FleetPickerProps) {
  const sortedOptions = options.toSorted((a, b) => statusPriority[a.status] - statusPriority[b.status]);

  return (
    <MenuList sx={{ px: 2 }}>
      {sortedOptions.map((option) => {
        const statusDisplayInfo = statusToDisplayInfo[option.status];
        return (
          <MenuItem
            key={option.id}
            onClick={() => onChange(option.id)}
            sx={{
              backgroundColor: option.id === value ? '#2047F414' : 'transparent',
              borderRadius: 0.5,
              mb: 2,
              py: 1,
            }}
          >
            <Avatar sx={{ bgcolor: stringToColor(option.name), color: 'white' }}>{option.name[0]}</Avatar>
            <Box sx={{ flex: 1, mx: 1.5, overflow: 'hidden' }}>
              <Typography sx={{ whiteSpace: 'wrap' }} variant="body1">
                {option.name}
              </Typography>
              <Typography color={statusDisplayInfo.color} variant="caption">
                {statusDisplayInfo.label}
              </Typography>
            </Box>
          </MenuItem>
        );
      })}
    </MenuList>
  );
}

export { FleetPicker };
